import Vue from '../vue/common/vue-common';
import GiftGuideV2 from '../vue/components/gift-guide/GiftGuideV2.vue';
import cr$ from '../common/crquery';
import HorizontalScrollbar from '../vue/components/common/container/HorizontalScrollbar.vue';
import { getSimpleVueHorizontalScroll } from '../vue/horizontal-scroll';

cr$.ready(function () {
    requestIdleCallback(() => new Vue(GiftGuideV2));

    const highlightsEl = cr$.byId('guia-de-presentes');
    if (highlightsEl.exists()) {
        requestIdleCallback(() => {
            new Vue({
                template: `<HorizontalScrolllbar />`,
                components: { HorizontalScrollbar },
            });
        });
    }

    const giftsImgEl = cr$.byId('presentoes-carousel');
    if (highlightsEl.exists()) {
        requestIdleCallback(() => getSimpleVueHorizontalScroll(giftsImgEl.raw));
    }

    const personalitiesImgEl = cr$.byId('personalities-carousel');
    if (highlightsEl.exists()) {
        requestIdleCallback(() => getSimpleVueHorizontalScroll(personalitiesImgEl.raw));
    }

    const aritclesImgEl = cr$.byId('articles-carousel');
    if (highlightsEl.exists()) {
        requestIdleCallback(() => getSimpleVueHorizontalScroll(aritclesImgEl.raw));
    }
});
